import { Formik, Form, FormikConfig } from "formik";

export const FormikForm = <T,>({ children, ...props }: FormikConfig<T>) => {
  return (
    <Formik {...props}>
      <Form>{children}</Form>
    </Formik>
  );
};
